<div class="cc-page">
  <!-- Loading State -->
  <div class="loading-container" *ngIf="loading">
    <div class="k-i-loading"></div>
  </div>

  <div class="cc-dashboard" *ngIf="empresa && !loading">
    <!-- Mensagem de Sucesso -->
    <div class="cc-toast" role="alert" *ngIf="msgSucesso">
      <i class="fas fa-check-circle"></i>
      <span>{{msgSucesso}}</span>
    </div>

    <!-- Header -->
    <div class="cc-header">
      <div class="cc-header-top">
        <button class="cc-btn-back" (click)="voltar()">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="cc-title-block">
          <h2 class="cc-title">Cartões Cliente</h2>
          <span class="cc-counter" *ngIf="quantidadeTotalCartoes || filtro">
            {{quantidadeCartoesExibidos}}
            <span *ngIf="filtro"> / {{quantidadeTotalCartoes}}</span>
            cartões
          </span>
        </div>
        <div class="cc-header-actions">
          <button class="cc-btn cc-btn-outline" (click)="abrirDialogGerarLote()">
            <i class="fas fa-layer-group"></i>
            Gerar Vários
          </button>
          <button class="cc-btn cc-btn-primary" (click)="novo()">
            <i class="fe-plus"></i>
            Novo Cartão
          </button>
        </div>
      </div>
      <div class="cc-search">
        <kendo-textbox
          name="filtro"
          [(ngModel)]="filtro"
          [showSuccessIcon]="false"
          placeholder="Buscar por código, PDV ou status...">
          <ng-template kendoTextBoxSuffixTemplate>
            <button kendoButton [look]="'clear'" [icon]="'search'"></button>
          </ng-template>
        </kendo-textbox>
      </div>
    </div>

    <!-- Grid de Cartões -->
    <div class="cc-grid">
      <div class="cc-card" *ngFor="let cartao of cartoesFiltrados; trackBy: trackByCartao"
           [class.cc-card--inactive]="!cartao.ativo">

        <!-- Status indicator strip -->
        <div class="cc-card-status-strip"
             [class.cc-card-status-strip--active]="cartao.ativo"
             [class.cc-card-status-strip--inactive]="!cartao.ativo">
        </div>

        <!-- Card header: código + badge -->
        <div class="cc-card-top">
          <div class="cc-card-codigo">
            <span class="cc-card-numero">{{cartao.codigo}}</span>
            <span class="cc-card-badge"
                  [class.cc-card-badge--active]="cartao.ativo"
                  [class.cc-card-badge--inactive]="!cartao.ativo">
              {{cartao.ativo ? 'Ativo' : 'Inativo'}}
            </span>
          </div>
        </div>

        <!-- QR Code centralizado -->
        <div class="cc-card-qr">
          <img [src]="obtenhaQrCode(cartao)" alt="QR Code {{cartao.codigo}}"/>
        </div>

        <!-- Info compacta: PDV e data na mesma linha -->
        <div class="cc-card-info">
          <div class="cc-card-meta">
            <i class="fas fa-barcode"></i>
            <span>PDV: <strong *ngIf="cartao.codigoPdv">{{cartao.codigoPdv}}</strong><em *ngIf="!cartao.codigoPdv" class="cc-sem-codigo">Sem código</em></span>
          </div>
          <div class="cc-card-meta">
            <i class="fas fa-calendar-alt"></i>
            <span>{{cartao.dataCriacao | date:'dd/MM/yyyy HH:mm'}}</span>
          </div>
        </div>

        <!-- Download -->
        <a [href]="obtenhaUrlQrCode(cartao.codigo)" class="cc-card-download" download>
          <i class="fas fa-download"></i>
          Download QR
        </a>

        <!-- Rodapé com ações -->
        <div class="cc-card-footer">
          <button (click)="editar(cartao)" class="cc-card-btn cc-card-btn--edit" kendoTooltip title="Editar">
            <i class="fa fa-edit"></i>
          </button>
          <button class="cc-card-btn cc-card-btn--delete" kendoTooltip title="Remover" (click)="abraDialogRemover(cartao)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>

      <!-- Mensagem quando não há cartões -->
      <div class="cc-empty" *ngIf="objetos.length === 0">
        <i class="fas fa-qrcode"></i>
        <p>Nenhum cartão cadastrado</p>
        <button class="cc-btn cc-btn-primary" (click)="novo()">
          <i class="fe-plus"></i> Criar primeiro cartão
        </button>
      </div>

      <!-- Mensagem quando nenhum cartão é encontrado -->
      <div class="cc-empty" *ngIf="filtro && quantidadeCartoesExibidos === 0 && objetos.length > 0">
        <i class="fas fa-search"></i>
        <p>Nenhum cartão encontrado para <strong>{{filtro}}</strong></p>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Confirmação -->
<kendo-dialog title="Confirmar a remoção" *ngIf="modalDeletar" (close)="close('cancel')" [minWidth]="250" [width]="450">
  <p class="confirmation-message">
    Você tem certeza que deseja apagar o cartão <strong>{{objetoApagar.codigo}}</strong>?
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="close('sim')" [primary]="true">Sim</button>
    <button kendoButton (click)="close('nao')">Não</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="Gerar vários cartões" *ngIf="modalGerarLote" (close)="closeGerarLote()" [minWidth]="250" [width]="520">
  <div class="bulk-dialog-content">
    <p class="bulk-dialog-description">
      Informe quantos cartões deseja criar. O sistema vai gerar códigos sequenciais automaticamente.
    </p>

    <div class="form-group">
      <label for="quantidadeGeracao">Quantidade</label>
      <input
        id="quantidadeGeracao"
        name="quantidadeGeracao"
        type="number"
        class="form-control"
        min="1"
        max="100"
        [(ngModel)]="quantidadeGeracao"
        [disabled]="gerandoLote"
        (keydown.enter)="gerarLote()">
      <small class="form-text text-muted">Limite de 100 cartões por geração.</small>
    </div>

    <div *ngIf="mensagemErroGeracao" class="alert alert-danger mt-3" role="alert">
      <i class="fas fa-exclamation-circle"></i>
      {{mensagemErroGeracao}}
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="closeGerarLote()" class="k-button-solid-base" [disabled]="gerandoLote">Cancelar</button>
    <button kendoButton (click)="gerarLote()" class="k-button-solid-success" [primary]="true" [disabled]="gerandoLote">
      <i class="fas fa-magic"></i>
      <span class="spinner-border spinner-border-sm me-2" *ngIf="gerandoLote"></span>
      Gerar Cartões
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
